import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { PaginationRequest } from '@shared/services';
import { RequestHelper } from '@shared/helpers/request.helper';

@Injectable({ providedIn: 'root' })
export class RoomApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) { }

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/rooms`;
    }

    getRooms(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(this.url, { params: options });
    }
    
    getOptions(req: PaginationRequest, body?: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.post<any>(`${this.url}/options`, body || {}, { params: options });
    }

    createRoom(room: any): Observable<any> {
        return this.httpClient.post<any>(this.url, room);
    }

    updateRoom(room: any): Observable<any> {
        return this.httpClient.put<any>(this.url, room);
    }
}
